import { request } from '@/shared/api/request'

const CONTROLLER = '/contract/eAdContract'
const TEENAGER = 'teenager'

export const getAdStatusKdpFamilyForEmployee = (params) => {
	return request({ url: `${CONTROLLER}/${TEENAGER}/statusKdpFamily`, method: 'GET', params })
}

export const sendAdKdpFamily = (params) => {
	return request({ url: `${CONTROLLER}/${TEENAGER}/sendKdpFamily`, method: 'POST', params })
}

export const sendAdSmsConsent = (params) => {
	return request({ url: `${CONTROLLER}/${TEENAGER}/sendSmsConsent`, method: 'POST', params })
}

export const verifyAdSmsConsent = (params) => {
	return request({ url: `${CONTROLLER}/${TEENAGER}/verifySmsConsent`, method: 'POST', params })
}

export const getAdXmlForRole = (params, payload) => {
	return request({ url: `${CONTROLLER}/${payload.role}/xml`, method: 'GET', params })
}

export const saveAdSign = (params, payload) => {
	return request({ url: `${CONTROLLER}/${payload.role}/saveSign`, method: 'POST', data: params })
}
